"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgRefreshCcw05 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M21.766 6.7a1 1 0 1 1-.518 1.932l-.406-.109c1.7 4.306.037 9.32-4.092 11.704a9.489 9.489 0 0 1-8.609.454 1 1 0 1 1 .811-1.828 7.502 7.502 0 0 0 10.149-9.272l-.092.344a1 1 0 0 1-1.932-.518l.732-2.732a1 1 0 0 1 1.225-.707l2.732.732ZM15.86 3.319a1 1 0 0 1-.812 1.828A7.503 7.503 0 0 0 4.9 14.42l.093-.345a1 1 0 1 1 1.931.518l-.732 2.732a1 1 0 0 1-1.224.707L2.235 17.3a1 1 0 1 1 .517-1.932l.406.109c-1.7-4.306-.037-9.32 4.092-11.704a9.488 9.488 0 0 1 8.61-.454Z", fill: "currentColor" }) }))); };
exports.default = SvgRefreshCcw05;
